var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("404 not found")]),_c('br'),_c('h4',[_vm._v("页面找不到,请核对连接是否正确~")])])
}]

export { render, staticRenderFns }